import { apiClient } from "../../../../helpers/api_helper";

export const getAllDiamondMakingChargesData = async (data: object) => {
  try {
    const response = await apiClient.get(
      `/api/v1/DiamondMakingCharges/GetAllDiamondMakingCharges`,
      data
    );
    return response;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const getDiamondMakingChargesById = async (id: any) => {
  try {
    const response = await apiClient.get(
      `api/v1/DiamondMakingCharges/GetDiamondMakingChargesDetailsById?Id=${id}`
    );
    return response;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const createDiamondMakingCharges = async (data: object) => {
  try {
    const response = await apiClient.post(
      "/api/v1/DiamondMakingCharges/InsertDiamondMakingCharges",
      data
    );
    return response;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const updateDiamondMakingCharges = async (data: object) => {
  try {
    const response = await apiClient.post(
      "/api/v1/DiamondMakingCharges/UpdateDiamondMakingCharges",
      data
    );
    return response;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const deleteDiamondMakingCharges = async (id: any) => {
  try {
    const response = await apiClient.delete(
      `/api/v1/DiamondMakingCharges/DeleteDiamondMakingCharges?Id=${id}`
    );
    return response;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const downloadDiamondMakingChargesExcel = async (
  filePath: string,
  fileName: string
) => {
  try {
    let url: string = process.env.REACT_APP_API_URL + filePath;
    let filename: string = fileName;
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error: any) {
    throw new Error(error.message);
  }
};
